<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<div class="h-100 d-flex flex-column">
  <div class="login-container flex-grow-1" data-automation="login-container" [style]="loginStyles">
    <div [hidden]="isLoading" class="login-container-inner">
      <!-- Display Alert if Server or License Issue detected -->
      @if (errorAlert) {
        <div
          [ngClass]="{
            'animate__animated animate__shakeX': attemptedLogin,
            'alert-danger': systemStatusError() || getSsoErrorMessage(),
            'alert-warning': !systemStatusError() && !getSsoErrorMessage(),
          }"
          data-automation="login-warnings"
          class="alert"
        >
          <h4 data-automation="login-warning-header" [innerHtml]="errorAlert?.header | escapeHtml"></h4>
          <div
            data-automation="login-warning-message"
            [innerHtml]="errorAlert?.message?.content || errorAlert?.message | escapeHtml: errorAlert?.message?.params"
          ></div>
        </div>
      }

      @if (infoAlert) {
        <div
          data-automation="login-branch-info"
          class="login-container-form__info-alert border-rad-all-2 d-flex justify-content-between align-items-center"
        >
          <div class="d-flex flex-column justify-content-center">
            <div>
              <i [ngClass]="ziroIcons.CODE_BRANCH" class="me-2"></i>
              <span data-automation="login-info-branch" [innerHtml]="infoAlert?.branch | escapeHtml"></span>
            </div>
            <div class="mt-1">
              <i [ngClass]="ziroIcons.ENVIRONMENT" class="me-2"></i>
              <span data-automation="login-info-environment" [innerHtml]="infoAlert?.environment | escapeHtml"></span>
            </div>
          </div>
          <div class="align-items-center">
            <i [ngClass]="infoAlertLogo" class="fa-2x"></i>
          </div>
        </div>
      }

      <div class="login-container-form">
        <div class="d-flex justify-content-center">
          <img class="company-logo-image" data-automation="company-logo-image" [src]="loginLogo" alt="Logo" />
        </div>

        @if (!outdatedBrowserError) {
          <div class="top-buffer mb-0">
            <!-- SAML SSO -->
            <div [hidden]="!showSamlSsoLogin()" data-automation="login-saml-form">
              <ziro-button
                id="saml-login-button"
                [dataAutomation]="'saml-login-button'"
                [label]="loginSubmitLabel"
                (clicked)="handleSamlSsoLogin()"
                [isDisabled]="isLoggingIn"
                [icon]="ziroIcons.LOCK"
                [iconPending]="ziroIcons.SAVING"
                [buttonSize]="buttonSizes.LARGE"
                [buttonStyle]="buttonStyles.PRIMARY"
                [isFullWidth]="true"
              ></ziro-button>
            </div>
            <!-- Local Auth -->
            <div [hidden]="!isSsoBypassed" data-automation="login-local-auth-form">
              <div>
                <form (keyup.enter)="onEnterSubmit()">
                  <ziro-text [fieldId]="'username'"></ziro-text>
                  <ziro-text [fieldId]="'password'"></ziro-text>
                </form>
                <ziro-submit-button
                  [isPending]="isLoggingIn"
                  [isDisabled]="isSubmitting"
                  [label]="loginSubmitLabel"
                  [dataAutomation]="'login-submit'"
                  [icon]="ziroIcons.LOCK"
                  [iconPending]="ziroIcons.SAVING"
                  [formSubmitSubject]="_validateAndSubmitSource"
                  [buttonSize]="buttonSizes.LARGE"
                  [buttonStyle]="buttonStyles.PRIMARY"
                  [buttonStylePending]="buttonStyles.PRIMARY"
                  [isFullWidth]="true"
                ></ziro-submit-button>
              </div>
            </div>
            <!-- OIDC -->
            <div [hidden]="!showOidcSsoLogin()" data-automation="login-oidc-form" class="mt-3">
              <ziro-button
                id="oidc-login-button"
                [dataAutomation]="'oidc-login-button'"
                [label]="microsoftOidcLabel"
                (clicked)="handleOidcLogin()"
                [isDisabled]="isLoggingIn"
                [iconPending]="ziroIcons.SAVING"
                [buttonSize]="buttonSizes.LARGE"
                [buttonStyle]="buttonStyles.DEFAULT"
                [isFullWidth]="true"
              ></ziro-button>
            </div>
          </div>
        }
        @if (outdatedBrowserError) {
          <div class="alert alert-danger">
            <h4 [innerHtml]="browserOutdatedHeader | escapeHtml"></h4>
            <div [innerHtml]="browserOutdatedMessage | escapeHtml"></div>
          </div>
        }
      </div>
    </div>
  </div>

  <ziro-footer>
    <div [hidden]="isSsoBypassed" class="text-center mb-n2">
      <div class="d-inline-block">
        <ziro-button
          [cssClass]="'w-100 mt-2 mb-n2'"
          [buttonStyle]="buttonStyles.LINK"
          [dataAutomation]="'switch-login'"
          [label]="bypassSsoLabel?.content | translate: bypassSsoLabel?.params"
          [icon]="ziroIcons.SIGN_IN"
          (clicked)="showZiroLogin()"
        ></ziro-button>
      </div>
    </div>
  </ziro-footer>
</div>
